/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from '@/axios.js'

const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({commit}, width) {
        commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({commit}, payload) {
        commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({commit}, list) {
        commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({commit}, list) {
        commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({commit}) {
        commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({commit}, val) {
        commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({commit}, payload) {
        commit('UPDATE_USER_INFO', payload)
    },
    updateUserRole({dispatch}, payload) {
        // Change client side
        payload.aclChangeRole(payload.userRole);

        // Make API call to server for changing role

        // Change userInfo in localStorage and store
        dispatch('updateUserInfo', {userRole: payload.userRole})
    },
    list({commit}, dados) {//Listagem global de qualquer tabela
        return new Promise((resolve, reject) => {
            axios.get(`/api/${dados.rota}/`, {params: dados.dados}).then((response) => {
                console.log(dados.rota, response);
                commit(dados.mutation, response.data.data.dados);
                resolve(response.data.data.dados.data)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    updateItem({commit}, dados) {

    },
    remove({commit}, dados) {
        return new Promise((resolve, reject) => {
            const payload = {
                _method: 'DELETE',
                id: dados.id
            };

            axios.post(`/api/${dados.rota}/${dados.id}`, payload).then((response) => {
                resolve(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    massRemove({commit}, dados) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/${dados.rota}/deleteMassa`, dados).then((response) => {
                resolve(response)
            }).catch((error) => {
                reject(error)
            })
        })
    }
};

export default actions
